import { render, staticRenderFns } from "./ttshop_coupon.vue?vue&type=template&id=ce306c8a&scoped=true&"
import script from "./ttshop_coupon.vue?vue&type=script&lang=js&"
export * from "./ttshop_coupon.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_coupon.vue?vue&type=style&index=0&id=ce306c8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce306c8a",
  null
  
)

export default component.exports